// FiltroMobileModal.tsx
import React from "react";
import { Modal, Button, DatePicker, Select, Form } from "antd";
import dayjs from "dayjs";

interface Props {
  visible: boolean;
  onClose: () => void;
  onApply: (values: any) => void;
  filtros: Record<string, any>;
}

const { Option } = Select;

const status = [
  { label: "Atendido MC", value: "Atendido MC" },
  { label: "Não Atendido", value: "Não Atendido" },
  { label: "Aguardando", value: "Aguardando" },
];

export const FiltroMobileModal: React.FC<Props> = ({
  visible,
  onClose,
  onApply,
  filtros,
}) => {
  const [form] = Form.useForm();

  const handleOk = () => {
    form.validateFields().then((values) => {
      onApply(values);
      onClose();
    });
  };

  const handleClear = () => {
    form.resetFields();
    onApply({});
    onClose();
  };

  return (
    <Modal
      title="Filtros"
      open={visible}
      onOk={handleOk}
      onCancel={onClose}
      footer={[
        <Button key="limpar" onClick={handleClear}>
          Limpar
        </Button>,
        <Button key="aplicar" type="primary" onClick={handleOk}>
          Aplicar
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical" initialValues={filtros}>
        <Form.Item name="status" label="Status">
          <Select
            mode="multiple"
            placeholder="Filtrar Status"
            style={{ width: "100%" }}
          >
            {status.map((item) => (
              <Option key={item.value} value={item.value}>
                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      display: "inline-block",
                      border: "grey solid 1px",
                    }}
                  />
                  {item.label}
                </span>
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Adicione outros filtros aqui se quiser, como check-in/check-out, etc. */}
      </Form>
    </Modal>
  );
};
